<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrApplicationRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi" header-btn-add-disabled header-btn-edit-disabled
                                      :ref="modelName+'Table'"
                                      with-custom-row-actions-first-column with-custom-row-actions>
                                <template #left-header>
                                    <em-button type="check" custom-icon="fa fa-fw fa-lg fa-link"
                                               custom-label="新增采购申请"
                                               show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openPrApplyDialog()"
                                    >
                                    </em-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                   :busy="claimLoading"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :custom-label="isClaim ? '认领' : '处理'"
                                                   @click="handleExecute(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <PrApplyForm :prApplyDialogVisible="prApplyDialogVisible"  @change="change" @doQuery="doQuery"></PrApplyForm>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author lidongxu
    // Date 2024-02-22 15:18:36

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import PrApplyForm from "@/components/SithMes/PrApplyForm.vue";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import emWorkflowListMixin from "@/mixin/em/workflow/list";
    import claimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";

    export default {
        name: "sithMesStoolPrApplicationRecordListView",
        components: {PrApplyForm},
        mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emCustomVuexMixin, emWorkflowListMixin, claimTaskMixins],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                prApplyDialogVisible: false
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            openPrApplyDialog() {
                this.prApplyDialogVisible = true;
            },
            change() {
                this.prApplyDialogVisible = false;
            },
            doQuery() {
                this.$refs.emListFilter.doQuery();
            },
            gotoChild(row) {
                if (row.purchasingType === '间接采购' || row.itemType === '库存') {
                    this.$_emGotoMixin_gotoHolderList("sithMesStoolPrApplicationIndirectPurchaseDetail"
                            , {applicationNoFilter: row.applicationNo}
                            , {applicationNo: row.applicationNo}, false, {})
                } else if (row.purchasingType === '直接采购'){
                    this.$_emGotoMixin_gotoHolderList("sithMesStoolPrApplicationShippingDetail"
                            , {applicationNoFilter: row.applicationNo}
                            , {applicationNo: row.applicationNo}, false, {})
                }
            },
        }
    };
</script>
